"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var helpers_exports = {};
__export(helpers_exports, {
  extendedRiverflySiltAndFlowLayer: () => extendedRiverflySiltAndFlowLayer,
  extendedRiverflyWaterQualityLayer: () => extendedRiverflyWaterQualityLayer,
  riverflyLayer: () => riverflyLayer,
  urbanRiverflyLayer: () => urbanRiverflyLayer
});
module.exports = __toCommonJS(helpers_exports);
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
const white = import_topo_map.marker.fromColor("#f7f7f7");
function speciesColor(hue, lightness) {
  return import_topo_map.marker.gradient(hue, 50, lightness);
}
const siteGroup = (0, import_topo_map.attributeGroup)({
  label: "Location",
  attributes: [
    (0, import_topo_map.stringAttr)({
      attributeId: "catchment",
      label: "Catchment",
      buckets: "auto"
    }),
    (0, import_topo_map.stringAttr)({ attributeId: "river", label: "River", buckets: "auto" }),
    (0, import_topo_map.stringAttr)({ attributeId: "site", label: "Site", buckets: "auto" }),
    (0, import_topo_map.timestampAttr)({
      attributeId: "timestamp",
      label: "Date/Time",
      buckets: "auto"
    }),
    (0, import_topo_map.surveyAttr)("surveyId"),
    (0, import_topo_map.teamAttr)("teamId", "Team"),
    (0, import_topo_map.stringAttr)({
      attributeId: "moduleId",
      label: "Survey Type",
      buckets: [
        (0, import_topo_map.lookupBucket)("riverfly", import_topo_map.marker.hue(210), "Riverfly"),
        (0, import_topo_map.lookupBucket)("urbanRiverfly", import_topo_map.marker.hue(30), "Urban Riverfly"),
        (0, import_topo_map.lookupBucket)("extendedRiverfly", import_topo_map.marker.hue(300), "Extended Riverfly")
      ]
    }),
    (0, import_topo_map.attachmentAttr)("fixedPointPhotographs", "Fixed Point Photographs")
  ]
});
const triggerGroup = (0, import_topo_map.attributeGroup)({
  label: "ARMI Pollution Warning",
  attributes: [
    (0, import_topo_map.enumAttr)({
      attributeId: "sampleType",
      label: "Sample Type",
      enum: import_inventory_enums.RiverflySampleTypeEnum,
      markers: {
        First: import_topo_map.marker.fromColor("lime"),
        Second: import_topo_map.marker.fromColor("orange"),
        Combined: import_topo_map.marker.fromColor("pink")
      }
    }),
    (0, import_topo_map.booleanAttr)({
      attributeId: "sampleTaken",
      label: "Sample Taken?",
      buckets: [
        (0, import_topo_map.lookupBucket)(true, import_topo_map.marker.fromColor("limegreen")),
        (0, import_topo_map.lookupBucket)(false, import_topo_map.marker.fromColor("orange")),
        (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty)
      ]
    }),
    (0, import_topo_map.thresholdAttr)({
      attributeId: "trigger",
      label: "Trigger Level",
      decimalPlaces: 0,
      buckets: [
        (0, import_topo_map.thresholdBucket)(0, speciesColor(210, 5 / 5)),
        (0, import_topo_map.thresholdBucket)(4, speciesColor(210, 4 / 5)),
        (0, import_topo_map.thresholdBucket)(8, speciesColor(210, 3 / 5)),
        (0, import_topo_map.thresholdBucket)(12, speciesColor(210, 2 / 5)),
        (0, import_topo_map.thresholdBucket)(16, speciesColor(210, 1 / 5))
      ]
    }),
    (0, import_topo_map.booleanAttr)({
      attributeId: "breach",
      label: "Trigger Level Breach",
      buckets: [
        (0, import_topo_map.lookupBucket)(true, import_topo_map.marker.fromColor("red"), "Yes"),
        (0, import_topo_map.lookupBucket)(false, import_topo_map.marker.fromColor("green"), "No")
      ]
    }),
    (0, import_topo_map.stringAttr)({
      attributeId: "breachType",
      label: "Trigger Level Breach Type",
      buckets: [
        (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.fromColor("white"), "No Breach"),
        (0, import_topo_map.lookupBucket)(import_inventory_enums.RiverflyBreachTypeEnum.Unconfirmed, import_topo_map.marker.fromColor("yellow"), "Unconfirmed"),
        (0, import_topo_map.lookupBucket)(import_inventory_enums.RiverflyBreachTypeEnum.Confirmed, import_topo_map.marker.fromColor("red"), "Confirmed")
      ],
      format: (value) => import_inventory_enums.RiverflyBreachTypeEnum.isValue(value) ? import_inventory_enums.RiverflyBreachTypeEnum.labelOf(value) : "-"
    }),
    (0, import_topo_map.attachmentAttr)("breachPhotographs", "Breach Photographs"),
    (0, import_topo_map.stringAttr)({
      attributeId: "breachAction",
      label: "Reporting Action Taken",
      buckets: [
        (0, import_topo_map.lookupBucket)(import_inventory_enums.RiverflySecondBreachActionEnum.Coordinator, import_topo_map.marker.fromColor("#a0a"), "Reported to Coordinator"),
        (0, import_topo_map.lookupBucket)(import_inventory_enums.RiverflySecondBreachActionEnum.Hotline, import_topo_map.marker.fromColor("#f0f"), "Reported to Hotline"),
        (0, import_topo_map.lookupBucket)(import_inventory_enums.RiverflySecondBreachActionEnum.None, import_topo_map.marker.fromColor("#ccc"), "Unreported"),
        (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty, "N/A")
      ],
      format: (value) => import_inventory_enums.RiverflySecondBreachActionEnum.isValue(value) ? import_inventory_enums.RiverflySecondBreachActionEnum.labelOf(value) : "-"
    })
  ]
});
function sampleScoresGroup(props) {
  const { label, speciesEnum, totalScoreThresholds = [4, 8, 12, 16] } = props;
  const numSpecies = speciesEnum.values.length;
  const totalAttr = (0, import_topo_map.thresholdAttr)({
    attributeId: "total",
    label: "Total Score",
    decimalPlaces: 0,
    buckets: [
      (0, import_topo_map.thresholdBucket)(null, speciesColor(30, 5 / 5)),
      (0, import_topo_map.thresholdBucket)(totalScoreThresholds[0], speciesColor(30, 4 / 5)),
      (0, import_topo_map.thresholdBucket)(totalScoreThresholds[1], speciesColor(30, 3 / 5)),
      (0, import_topo_map.thresholdBucket)(totalScoreThresholds[2], speciesColor(30, 2 / 5)),
      (0, import_topo_map.thresholdBucket)(totalScoreThresholds[3], speciesColor(30, 1 / 5))
    ]
  });
  const scoreAttr = (value, label2, index) => (0, import_topo_map.numberAttr)({
    attributeId: `score_${value}`,
    label: label2,
    decimalPlaces: 0,
    buckets: [
      (0, import_topo_map.rangeBucket)(null, 1, white, "0"),
      (0, import_topo_map.rangeBucket)(1, 2, speciesColor(360 * index / numSpecies, 3 / 3), "1"),
      (0, import_topo_map.rangeBucket)(2, 3, speciesColor(360 * index / numSpecies, 2 / 3), "2"),
      (0, import_topo_map.rangeBucket)(3, 4, speciesColor(360 * index / numSpecies, 1 / 3), "3"),
      (0, import_topo_map.rangeBucket)(4, null, speciesColor(360 * index / numSpecies, 0 / 3), "4")
    ],
    showDistribution: true,
    showTimeline: true
  });
  const scoreAttrs = speciesEnum.entries.map(({ value, label: label2 }, index) => scoreAttr(value, label2, index));
  return (0, import_topo_map.attributeGroup)({ label, attributes: [totalAttr, ...scoreAttrs] });
}
function sampleCountsGroup(props) {
  const { label, speciesEnum } = props;
  const numSpecies = speciesEnum.values.length;
  const speciesAttr = (value, label2, index) => (0, import_topo_map.numberAttr)({
    attributeId: `count_${value}`,
    label: label2,
    decimalPlaces: 0,
    buckets: [
      (0, import_topo_map.rangeBucket)(0, 1, white, "0"),
      (0, import_topo_map.rangeBucket)(1, 10, speciesColor(360 * index / numSpecies, 3 / 3), "1-9"),
      (0, import_topo_map.rangeBucket)(10, 100, speciesColor(360 * index / numSpecies, 2 / 3), "10-99"),
      (0, import_topo_map.rangeBucket)(100, 1e3, speciesColor(360 * index / numSpecies, 1 / 3), "100-999"),
      (0, import_topo_map.rangeBucket)(1e3, null, speciesColor(360 * index / numSpecies, 0 / 3), "1000+")
    ],
    showDistribution: true,
    showTimeline: true
  });
  return (0, import_topo_map.attributeGroup)({
    label,
    attributes: speciesEnum.entries.map(({ value, label: label2 }, index) => speciesAttr(value, label2, index))
  });
}
function riverflyLayer(projects, title) {
  return (0, import_topo_map.pointLayer)({
    layerId: (0, import_topo_map.unsafeMapLayerId)("riverfly"),
    title,
    source: (0, import_core.cartographerSourceWithDefaults)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("riverfly"),
      projects,
      attribution: []
    }),
    defaultAttribute: "total",
    defaultZOrder: "timestamp",
    attributes: [
      siteGroup,
      triggerGroup,
      sampleScoresGroup({
        label: "ARMI Scores",
        speciesEnum: import_inventory_enums.RiverflySpeciesEnum
      }),
      sampleCountsGroup({ label: "Counts", speciesEnum: import_inventory_enums.RiverflySpeciesEnum })
    ]
  });
}
function urbanRiverflyLayer(projects, title) {
  return (0, import_topo_map.pointLayer)({
    layerId: (0, import_topo_map.unsafeMapLayerId)("urbanRiverfly"),
    title,
    source: (0, import_core.cartographerSourceWithDefaults)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("urbanRiverfly"),
      projects,
      attribution: []
    }),
    defaultAttribute: "total",
    defaultZOrder: "timestamp",
    attributes: [
      siteGroup,
      sampleScoresGroup({
        label: "Urban Riverfly Scores",
        speciesEnum: import_inventory_enums.UrbanRiverflySpeciesEnum
      }),
      sampleCountsGroup({
        label: "Counts",
        speciesEnum: import_inventory_enums.UrbanRiverflySpeciesEnum
      })
    ]
  });
}
function extendedRiverflyWaterQualityLayer(project, title) {
  return (0, import_topo_map.pointLayer)({
    layerId: (0, import_topo_map.unsafeMapLayerId)("extendedRiverflyWaterQuality"),
    title,
    source: (0, import_core.cartographerSourceWithDefaults)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("extendedRiverflyWaterQuality"),
      projects: [project],
      attribution: []
    }),
    defaultAttribute: "total",
    defaultZOrder: "timestamp",
    attributes: [
      siteGroup,
      sampleScoresGroup({
        label: "Water Quality Scores",
        speciesEnum: import_inventory_enums.ExtendedRiverflySpeciesEnum,
        totalScoreThresholds: [10, 20, 30, 40]
      }),
      sampleCountsGroup({
        label: "Counts",
        speciesEnum: import_inventory_enums.ExtendedRiverflySpeciesEnum
      })
    ]
  });
}
function extendedRiverflySiltAndFlowLayer(project, title) {
  return (0, import_topo_map.pointLayer)({
    layerId: (0, import_topo_map.unsafeMapLayerId)("extendedRiverflySiltAndFlow"),
    title,
    source: (0, import_core.cartographerSourceWithDefaults)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("extendedRiverflySiltAndFlow"),
      projects: [project],
      attribution: []
    }),
    defaultAttribute: "total",
    defaultZOrder: "timestamp",
    attributes: [
      siteGroup,
      sampleScoresGroup({
        label: "Silt and Flow Scores",
        speciesEnum: import_inventory_enums.ExtendedRiverflySpeciesEnum,
        totalScoreThresholds: [10, 20, 30, 40]
      }),
      sampleCountsGroup({
        label: "Counts",
        speciesEnum: import_inventory_enums.ExtendedRiverflySpeciesEnum
      })
    ]
  });
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  extendedRiverflySiltAndFlowLayer,
  extendedRiverflyWaterQualityLayer,
  riverflyLayer,
  urbanRiverflyLayer
});
//# sourceMappingURL=helpers.js.map
